/* EWC mini slider — reproduz o comportamento do carrossel da referência (lista deslocada por transform,
   clones para loop, setas, pontinhos, autoplay e arraste) sem a biblioteca de terceiro.
   Configuração por data-ewc-* no <splide-component>:
     data-ewc-per-page="1" data-ewc-per-page-mobile="2"   itens por tela
     data-ewc-gap="16" data-ewc-gap-mobile="15"           vão entre itens (px)
     data-ewc-padding-mobile="15"                          respiro lateral no celular (px)
     data-ewc-loop="true" data-ewc-clones="2"              loop com N clones de cada lado
     data-ewc-autoplay="5000" data-ewc-initial-delay="12000"
     data-ewc-start="3"                                    índice inicial (contando clones)
     data-ewc-destroy-desktop="true"                       no desktop vira grade (sem slider)
     data-ewc-arrows="true" data-ewc-dots="true"
*/
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function num(v, d) { var n = parseFloat(v); if (!isNaN(n)) return n; var m = parseFloat(d); return isNaN(m) ? 0 : m; }

  function EwcSlider(root) {
    this.root = root;
    this.splide = root.querySelector('.splide');
    this.track = root.querySelector('.splide__track');
    this.list = root.querySelector('.splide__list');
    if (!this.track || !this.list) return;
    var ds = root.dataset;
    this.cfg = {
      perPage: num(ds.ewcPerPage, 1), perPageMobile: num(ds.ewcPerPageMobile, ds.ewcPerPage || 1),
      gap: num(ds.ewcGap, 0), gapMobile: num(ds.ewcGapMobile, ds.ewcGap || 0),
      paddingMobile: num(ds.ewcPaddingMobile, 0), padding: num(ds.ewcPadding, 0),
      loop: ds.ewcLoop === 'true', clones: num(ds.ewcClones, 0), clonesMobile: num(ds.ewcClonesMobile, ds.ewcClones || 0),
      autoplay: num(ds.ewcAutoplay, 0), initialDelay: num(ds.ewcInitialDelay, 0),
      start: num(ds.ewcStart, 0), startMobile: num(ds.ewcStartMobile, ds.ewcStart || 0),
      destroyDesktop: ds.ewcDestroyDesktop === 'true', arrows: ds.ewcArrows === 'true', dots: ds.ewcDots === 'true'
    };
    this.originals = Array.prototype.slice.call(this.list.children);
    this.index = 0; this.timer = null; this.built = false; this.mobile = null;
    var self = this;
    this.mq = window.matchMedia(MOBILE);
    this.rebuild();
    var onChange = function () { self.rebuild(); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', onChange); else this.mq.addListener(onChange);
    window.addEventListener('resize', function () { self.layout(); });
    this.bindArrows(); this.bindDrag();
  }

  EwcSlider.prototype.isMobile = function () { return this.mq.matches; };

  EwcSlider.prototype.rebuild = function () {
    var mobile = this.isMobile();
    if (this.built && this.mobile === mobile) { this.layout(); return; }
    this.mobile = mobile; this.built = true;
    var self = this;
    // limpa clones
    Array.prototype.slice.call(this.list.querySelectorAll('.splide__slide--clone')).forEach(function (c) { c.parentNode.removeChild(c); });
    this.originals.forEach(function (li) { li.classList.remove('is-active', 'is-visible', 'is-prev', 'is-next'); li.style.transform = ''; });
    this.list.style.transform = ''; this.list.style.transition = '';
    this.active = !(mobile ? false : this.cfg.destroyDesktop);
    this.splide.classList.toggle('is-active', this.active);
    if (!this.active) { this.stop(); this.updateDots(); return; }
    var clones = mobile ? this.cfg.clonesMobile : this.cfg.clones;
    if (this.cfg.loop && clones > 0) {
      var n = this.originals.length;
      for (var i = 0; i < clones; i++) {
        var before = this.originals[(((n - clones + i) % n) + n) % n].cloneNode(true); before.classList.add('splide__slide--clone'); before.setAttribute('aria-hidden', 'true');
        this.list.insertBefore(before, this.originals[0]);
        var after = this.originals[i % n].cloneNode(true); after.classList.add('splide__slide--clone'); after.setAttribute('aria-hidden', 'true');
        this.list.appendChild(after);
      }
    }
    this.slides = Array.prototype.slice.call(this.list.children);
    this.index = mobile ? this.cfg.startMobile : this.cfg.start;
    this.layout(true);
    this.start();
  };

  EwcSlider.prototype.metrics = function () {
    var mobile = this.isMobile();
    return { perPage: mobile ? this.cfg.perPageMobile : this.cfg.perPage, gap: mobile ? this.cfg.gapMobile : this.cfg.gap,
             padding: mobile ? this.cfg.paddingMobile : this.cfg.padding };
  };

  EwcSlider.prototype.layout = function (instant) {
    if (!this.active) return;
    var m = this.metrics(), self = this;
    var trackW = this.track.clientWidth;
    var w = (trackW - m.padding * 2 - m.gap * (m.perPage - 1)) / m.perPage;
    this.slideW = w; this.step = w + m.gap;
    this.slides.forEach(function (li, i) { li.style.width = w + 'px'; li.style.marginRight = m.gap + 'px'; });
    this.go(this.index, instant);
  };

  EwcSlider.prototype.go = function (i, instant) {
    var m = this.metrics(), self = this;
    this.index = i;
    var x = -i * this.step;   // o respiro lateral vem do padding do track (como na referência)
    this.list.style.transition = instant ? 'none' : 'transform 400ms ease';
    this.list.style.transform = 'translateX(' + x + 'px)';
    this.slides.forEach(function (li, k) {
      li.classList.toggle('is-active', k === i);
      li.classList.toggle('is-visible', k >= i && k < i + m.perPage);
      li.classList.toggle('is-prev', k === i - 1); li.classList.toggle('is-next', k === i + m.perPage);
    });
    this.updateDots(); this.updateArrows();
  };

  EwcSlider.prototype.updateArrows = function () {
    var clones = this.isMobile() ? this.cfg.clonesMobile : this.cfg.clones;
    var loop = this.cfg.loop && clones > 0, m = this.metrics();
    var prev = this.root.querySelector('.splide__arrow--prev'), next = this.root.querySelector('.splide__arrow--next');
    if (prev) prev.disabled = !loop && this.index <= 0;
    if (next) next.disabled = !loop && this.index >= this.originals.length - m.perPage;
  };

  EwcSlider.prototype.move = function (dir) {
    var n = this.originals.length, m = this.metrics(), self = this;
    var clones = this.isMobile() ? this.cfg.clonesMobile : this.cfg.clones;
    var loop = this.cfg.loop && clones > 0;
    var target = this.index + dir;
    if (!loop) { target = Math.max(0, Math.min(n - m.perPage, target)); this.go(target); return; }
    this.go(target);
    // volta silenciosa quando entra nos clones
    var lo = clones, hi = clones + n - 1;
    if (target > hi || target < lo) {
      var back = target > hi ? target - n : target + n;
      var done = function () { self.list.removeEventListener('transitionend', done); self.go(back, true); };
      this.list.addEventListener('transitionend', done);
      setTimeout(done, 450);
    }
  };

  EwcSlider.prototype.start = function () {
    var self = this; this.stop();
    if (!this.cfg.autoplay || !this.active) return;
    this.timer = setTimeout(function tick() {
      self.move(1);
      self.timer = setTimeout(tick, self.cfg.autoplay);
    }, this.cfg.initialDelay || this.cfg.autoplay);
  };
  EwcSlider.prototype.stop = function () { if (this.timer) { clearTimeout(this.timer); this.timer = null; } };

  EwcSlider.prototype.bindArrows = function () {
    var self = this;
    var prev = this.root.querySelector('.splide__arrow--prev'), next = this.root.querySelector('.splide__arrow--next');
    if (prev) prev.addEventListener('click', function () { self.stop(); self.move(-1); });
    if (next) next.addEventListener('click', function () { self.stop(); self.move(1); });
  };

  EwcSlider.prototype.updateDots = function () {
    var dots = this.root.querySelectorAll('.splide__pagination__page');
    if (!dots.length) return;
    var clones = this.isMobile() ? this.cfg.clonesMobile : this.cfg.clones;
    var real = ((this.index - (this.cfg.loop ? clones : 0)) % this.originals.length + this.originals.length) % this.originals.length;
    var self = this;
    Array.prototype.forEach.call(dots, function (d, k) {
      d.classList.toggle('is-active', k === real);
      if (!d._ewc) { d._ewc = true; d.addEventListener('click', function () { self.stop(); self.go(k + (self.cfg.loop ? clones : 0)); }); }
    });
  };

  // Arraste que acompanha o dedo, como o carrossel da referencia. A versao anterior so olhava o
  // pointerdown e o pointerup: no celular o navegador tratava o gesto como rolagem da pagina,
  // disparava pointercancel e a faixa nunca se mexia ("travando ao deslizar").
  // touch-action: pan-y deixa a rolagem VERTICAL com o navegador e o horizontal com o slider.
  EwcSlider.prototype.bindDrag = function () {
    var self = this, x0 = null, y0 = null, base = 0, dx = 0, arrastando = false, id = null, t0 = 0;
    this.track.style.touchAction = 'pan-y';
    var atual = function () {
      var m = /translateX\((-?[\d.]+)px\)/.exec(self.list.style.transform || '');
      return m ? parseFloat(m[1]) : -self.index * self.step;
    };
    this.track.addEventListener('pointerdown', function (e) {
      if (!self.active || (e.pointerType === 'mouse' && e.button !== 0)) return;
      x0 = e.clientX; y0 = e.clientY; dx = 0; arrastando = false; id = e.pointerId; t0 = Date.now();
      base = atual();
    });
    this.track.addEventListener('pointermove', function (e) {
      if (x0 === null || e.pointerId !== id) return;
      var mx = e.clientX - x0, my = e.clientY - y0;
      if (!arrastando) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        if (Math.abs(my) > Math.abs(mx)) { x0 = null; return; }   // gesto vertical: e rolagem da pagina
        arrastando = true; self.stop();
        try { self.track.setPointerCapture(id); } catch (err) {}
        self.list.style.transition = 'none';
      }
      dx = mx;
      self.list.style.transform = 'translateX(' + (base + dx) + 'px)';
    });
    var soltar = function (e) {
      if (x0 === null) return;
      x0 = null;
      if (!arrastando) return;
      arrastando = false;
      var passos = Math.abs(dx) > 30 ? Math.max(1, Math.round(Math.abs(dx) / (self.step || 1))) : 0;
      // gesto rapido (flick) anda uma pagina inteira, como o Splide da referencia
      var vel = Math.abs(dx) / Math.max(1, Date.now() - t0);
      if (passos && vel > 0.45) passos = Math.max(passos, Math.max(1, Math.floor(self.metrics().perPage)));
      if (passos) { self.move(dx < 0 ? passos : -passos); } else { self.go(self.index); }
      // um arraste nao e clique no card
      var bloquear = function (ev) { ev.preventDefault(); ev.stopPropagation(); self.track.removeEventListener('click', bloquear, true); };
      self.track.addEventListener('click', bloquear, true);
      setTimeout(function () { self.track.removeEventListener('click', bloquear, true); }, 50);
    };
    this.track.addEventListener('pointerup', soltar);
    this.track.addEventListener('pointercancel', soltar);
    this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('splide-component[data-ewc-per-page]'), function (el) {
      if (el._ewcSlider) return;
      try { el._ewcSlider = new EwcSlider(el); } catch (e) { if (window.console) console.error('ewc-slider', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.EwcSlider = EwcSlider;
})();
